import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "semantic-ui-css/semantic.min.css";
import { Container, Dropdown, Icon } from "semantic-ui-react";
import { Link } from "react-router-dom";

const Footer = () => {
  const [properties, setProperties] = useState({
    background: "#455437",
    color: "#F8EEE8",
    logoColor: "#D6DDCD",
  });

  const location = useLocation();
  useEffect(() => {
    if (location.pathname === "/") {
      setProperties({
        background: "#EBDFD6",
        color: "#0F120D",
        logoColor: "#F8EEE8",
      });
    } else {
      setProperties({
        background: "#455437",
        color: "#F8EEE8",
        logoColor: "#D6DDCD",
      });
    }
  }, [location.pathname]);
  return (
    <div
      className="text-light"
      style={{
        background: `${properties.background}`,
      }}
    >
      <Container>
        <div
          className="d-flex pt-5"
          style={{
            color: `${properties.color}`,
          }}
        >
          <div className="me-5">
            <p className="fw-bold pb-3">
              <u>About</u>
            </p>

            <p>
              <Link
                to="/searchdetail/venue"
                style={{ textDecoration: "none", color: `${properties.color}` }}
              >
                Venue
              </Link>
            </p>

            <p>
              <Link
                to="/searchdetail/organizer"
                style={{ textDecoration: "none", color: `${properties.color}` }}
              >
                Wedding Organizer
              </Link>
            </p>
          </div>
          <div>
            <p className="fw-bold underline pb-3">
              <u>Support</u>
            </p>
            <p>Help Center</p>
            <p>Contact us</p>
          </div>
        </div>
        <div
          style={{
            textAlign: "end",
          }}
        >
          <svg
            width="290"
            height="84"
            viewBox="0 0 290 84"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{
              marginBottom: "-1.66rem",
              textAlign: "end",
            }}
          >
            <g opacity="0.8">
              <path
                d="M41.1206 60.6799H38.1709L28.9531 34.4889L18.9611 60.6799H16.0114L5.06066 30.4695C4.8093 29.7115 4.34121 29.0447 3.71487 28.5524C3.28263 28.1878 2.79778 27.8911 2.2769 27.6726C1.92663 27.5615 1.17999 27.3577 0.0185547 27.0614V24.4497H16.0114V27.0614C15.5925 27.2162 15.1487 27.2916 14.7024 27.2837C14.1661 27.2909 13.6355 27.3943 13.1354 27.5893C12.9295 27.6847 12.7507 27.8305 12.6155 28.0133C12.4802 28.1962 12.3927 28.4102 12.3611 28.6358C12.3959 29.2653 12.5105 29.8877 12.7022 30.4881L19.6432 50.9463L29.543 24.496H32.5019L41.8027 50.9463L49.8774 30.5158C50.1094 29.94 50.2644 29.3359 50.3383 28.7191V28.6265C50.3383 27.8115 49.0017 27.2929 46.3378 27.0521V24.4404H58.5882V27.0521C55.7491 27.2929 53.924 28.4228 53.1129 30.4603L41.1206 60.6799Z"
                fill={properties.logoColor}
              />
              <path
                d="M94.5834 41.2129H69.7784C69.7784 52.6228 73.487 58.3278 80.9042 58.3278C85.2058 58.3278 88.9144 56.1143 92.0301 51.6874L94.5465 53.0859C90.9577 58.7908 85.9771 61.6433 79.6045 61.6433C74.2644 61.6433 69.9627 59.8806 66.6996 56.3551C63.4366 52.8296 61.8173 48.3626 61.8419 42.954C61.7128 37.9209 63.3914 33.0094 66.5706 29.1176C69.7354 25.302 73.9817 23.3941 79.3095 23.3941C81.4584 23.3112 83.5953 23.7523 85.5376 24.6796C87.4799 25.607 89.1699 26.9931 90.463 28.7194C93.2155 32.2893 94.6695 36.6979 94.5834 41.2129ZM86.8497 38.1567C86.8497 38.1011 86.8497 37.9622 86.8958 37.7584C86.9056 37.598 86.9056 37.4372 86.8958 37.2768C86.8958 30.1827 84.2288 26.6325 78.8947 26.6263C77.5907 26.5511 76.29 26.8222 75.1233 27.4124C73.9567 28.0025 72.9652 28.8909 72.2487 29.9882C70.7094 32.4336 69.8824 35.2633 69.8613 38.1567H86.8497Z"
                fill={properties.logoColor}
              />
              <path
                d="M130.615 28.636V12.1323C130.615 7.53871 128.674 5.21103 124.79 5.14929V2.445C129.178 1.86659 133.531 1.05352 137.833 0.00927734V51.002C137.833 55.5956 139.802 57.9233 143.742 57.985V60.6893C140.608 60.6893 137.102 60.8344 133.224 61.1246C132.623 60.0094 132.212 58.8012 132.007 57.5498C127.706 60.2787 123.533 61.6463 119.49 61.6525C117.038 61.741 114.596 61.2952 112.331 60.3456C110.067 59.396 108.034 57.9651 106.373 56.1513C102.983 52.4146 101.174 47.4983 101.331 42.4446C101.331 36.9681 102.867 32.4269 105.94 28.8212C109.012 25.2154 113.243 23.4095 118.632 23.4033C123.843 23.3972 127.838 25.1414 130.615 28.636ZM130.615 51.5114V33.6185C128.87 29.4201 125.183 27.3239 119.554 27.3301C117.712 27.2793 115.896 27.7788 114.337 28.7656C112.891 29.7259 111.756 31.0911 111.074 32.6924C110.371 34.3024 109.86 35.9905 109.553 37.7213C109.257 39.5087 109.113 41.318 109.12 43.1299C109.045 46.8014 109.962 50.4245 111.774 53.6137C112.585 55.0654 113.784 56.26 115.235 57.0621C116.687 57.8642 118.333 58.2416 119.987 58.1517C124.523 58.1517 128.065 55.9383 130.615 51.5114Z"
                fill={properties.logoColor}
              />
              <path
                d="M170.243 24.4499V36.4062H168.243C167.721 33.8497 166.57 31.4651 164.897 29.4695C164.138 28.532 163.177 27.781 162.086 27.2738C160.995 26.7666 159.803 26.5166 158.601 26.5429C157.936 26.5217 157.274 26.6345 156.653 26.8747C156.033 27.1149 155.466 27.4776 154.988 27.9414C154.521 28.4042 154.154 28.9591 153.912 29.5712C153.669 30.1833 153.555 30.8392 153.577 31.4977C153.596 32.2277 153.777 32.9442 154.108 33.5948C154.438 34.2454 154.908 34.8136 155.485 35.2578C156.871 36.4295 158.425 37.3849 160.094 38.0918C161.895 38.8821 163.704 39.7557 165.523 40.7127C167.34 41.6679 168.928 43.0077 170.178 44.6395C171.462 46.3314 172.135 48.4119 172.086 50.539C172.151 52.008 171.922 53.4751 171.414 54.854C170.906 56.2329 170.129 57.4959 169.128 58.5685C168.108 59.5959 166.886 60.3983 165.54 60.9245C164.194 61.4507 162.754 61.6892 161.311 61.6248C157.63 61.6329 154.086 60.2283 151.402 57.698L149.927 60.6616H147.844V48.1681H149.89C150.174 50.8871 151.37 53.4282 153.282 55.3734C154.191 56.3214 155.285 57.0707 156.495 57.5743C157.705 58.0779 159.006 58.325 160.315 58.2999C161.895 58.3331 163.436 57.805 164.666 56.8089C165.26 56.3466 165.736 55.7499 166.056 55.0675C166.377 54.3851 166.532 53.6363 166.51 52.8821C166.502 52.0934 166.326 51.3155 165.996 50.6001C165.665 49.8848 165.187 49.2483 164.592 48.733C163.225 47.4778 161.67 46.4464 159.984 45.6768C158.183 44.8371 156.386 43.9357 154.591 42.9725C152.809 42.0216 151.241 40.7134 149.982 39.129C148.718 37.5585 148.043 35.5919 148.074 33.5723C147.949 30.8487 148.9 28.1856 150.72 26.1632C151.655 25.2211 152.776 24.4869 154.012 24.0082C155.247 23.5296 156.569 23.3172 157.891 23.3848C161.08 23.3848 163.978 24.7833 166.583 27.5802L168.233 24.4406L170.243 24.4499Z"
                fill={properties.logoColor}
              />
              <path
                d="M189.102 57.6239V74.2942C189.102 77.0726 189.655 78.9249 190.752 79.851C191.849 80.7771 193.822 81.2587 196.661 81.3791V83.9908H176.068V81.2865C178.262 81.2309 179.755 80.6289 180.677 79.4991C181.599 78.3692 181.931 76.628 181.931 74.3034V35.9709C181.931 31.4329 179.992 29.0744 176.114 28.8953V26.2836C180.132 25.7444 184.108 24.9274 188.015 23.8387C188.843 25.3592 189.235 27.0807 189.148 28.812C190.618 27.1185 192.435 25.7653 194.475 24.846C196.515 23.9266 198.73 23.4628 200.966 23.4867C206.005 23.4867 209.999 25.305 212.949 28.9416C215.941 32.6819 217.513 37.3695 217.382 42.1667C217.509 47.1385 215.912 51.9998 212.866 55.9198C209.855 59.7354 205.74 61.6433 200.523 61.6433C196.357 61.741 192.297 60.3123 189.102 57.6239ZM189.102 53.6137C191.514 56.2609 194.841 57.8839 198.403 58.1518C199.633 58.1866 200.858 57.9679 202.001 57.5091C203.144 57.0504 204.181 56.3614 205.049 55.4845C206.771 53.7915 208.015 51.6693 208.653 49.335C209.293 46.8841 209.603 44.3579 209.575 41.8241C209.653 38.2397 208.845 34.6919 207.224 31.4977C206.52 30.0735 205.416 28.888 204.048 28.0879C202.68 27.2879 201.108 26.9086 199.528 26.9968C195.644 26.9968 192.169 29.3831 189.102 34.1557V53.6137Z"
                fill={properties.logoColor}
              />
              <path
                d="M287.474 24.1812V26.9596H277.833V49.4831C277.807 51.1664 278.147 52.835 278.828 54.3731C279.076 55.0344 279.525 55.6009 280.11 55.993C280.695 56.3851 281.388 56.5829 282.091 56.5588C282.98 56.5352 283.847 56.2799 284.608 55.8179C285.223 55.4948 285.807 55.1133 286.35 54.6787C286.636 54.4194 287.272 53.7989 288.258 52.8264L290 54.3083C287.161 58.7907 283.624 61.032 279.39 61.032C273.534 61.032 270.609 57.1885 270.615 49.5016V26.9781H266.356V25.0611C267.737 24.8434 269.042 24.2866 270.156 23.4399C271.271 22.5933 272.16 21.4831 272.744 20.2081C274.165 17.4434 274.896 14.3732 274.874 11.2617H277.833V24.2275L287.474 24.1812Z"
                fill={properties.logoColor}
              />
              <path
                d="M242.593 26.0429L245.45 23.4868L242.593 26.0429Z"
                fill={properties.logoColor}
              />
              <path
                d="M242.593 26.043H242.362L242.473 26.1356L242.593 26.043Z"
                fill={properties.logoColor}
              />
              <path
                d="M233.929 18.5317L239.681 23.6625L242.363 26.0519H242.593L245.451 23.4958L246.705 22.3752L251 18.541L233.929 18.5317Z"
                fill={properties.logoColor}
              />
              <path
                d="M256.89 28.6361C254.751 26.366 251.994 24.7782 248.963 24.0703L248.714 24.2926L246.29 26.4597C246.842 26.6086 247.379 26.8102 247.894 27.0617C249.149 27.6803 250.237 28.5955 251.064 29.729C251.897 30.9564 252.52 32.3149 252.908 33.7484C253.343 35.1977 253.633 36.6868 253.774 38.1938C253.894 39.5645 253.95 41.1204 253.95 42.8244C253.973 45.3524 253.694 47.874 253.12 50.3353C252.557 52.637 251.37 54.7369 249.691 56.4015C248.819 57.2857 247.774 57.9784 246.623 58.436C245.471 58.8935 244.237 59.1058 242.999 59.0595C239.115 59.0595 236.334 57.516 234.657 54.4289C232.895 50.998 232.03 47.1741 232.14 43.3153C232.14 34.1404 234.436 28.6022 239.026 26.7005L236.39 24.3481C233.726 25.1889 231.321 26.7 229.403 28.738C226.011 32.3499 224.314 37.0948 224.314 42.9726C224.314 48.7332 225.995 53.2712 229.357 56.5867C232.718 59.9023 237.265 61.5631 242.999 61.5693C248.566 61.5693 253.086 59.8066 256.558 56.2811C260.03 52.7556 261.769 48.2022 261.775 42.6207C261.763 36.7923 260.135 32.1307 256.89 28.6361Z"
                fill={properties.logoColor}
              />
              <path
                d="M232.729 15.7536C233.476 14.5126 234.158 13.3457 234.896 12.2158C234.982 12.1244 235.087 12.0518 235.203 12.0024C235.318 11.953 235.443 11.9279 235.569 11.9287C240.171 11.9287 244.78 11.9287 249.395 11.9287C249.533 11.9337 249.668 11.9676 249.792 12.0282C249.916 12.0888 250.025 12.1748 250.114 12.2807C250.833 13.392 251.497 14.5312 252.234 15.7536H232.729Z"
                fill={properties.logoColor}
              />
            </g>
          </svg>
        </div>
        <div
          className="d-flex justify-content-between pb-5"
          style={{
            borderTop: `solid ${properties.logoColor} 1px`,
            paddingTop: "1.7rem",
          }}
        >
          <div
            className="d-flex"
            style={{
              color: `${properties.color}`,
            }}
          >
            <Dropdown
              text={
                <div>
                  <p>
                    {" "}
                    <Icon name="globe" /> English
                  </p>
                </div>
              }
            ></Dropdown>
            <p className="ms-5">Privacy Policy </p>
            <p className="ms-5">Terms Conditions</p>
          </div>
          <p
            style={{
              color: `${properties.color}`,
            }}
          >
            © Copyright 2021. All right reserved.
          </p>
        </div>
      </Container>
    </div>
  );
};

export default Footer;
